import moment from 'moment';

import { COUNTRY } from 'common/constants';
import Logger from 'utils/Logger';

export const STEP_KEY = {
  LOCATION: 'location',
  WELCOME: 'welcome',
  ATTITUDE: 'attitude',
  CRITERIA: 'criteria',
  CONTACT: 'contact',
  ANXIETY: 'anxiety',
  GENDER: 'gender',
  REASON: 'reason',
  REASON_DETAILS: 'reason_details',
  SPECIALIST_TYPE: 'specialist_type',
  SPECIALIST_REFERRAL: 'specialist_referral',
  GOALS: 'goals',
  LAST_VISITED: 'last_visited',
  AVAILABILITY: 'availability',
  HOW_SOON: 'how_soon',
  INSURANCE: 'insurance',
  READY_TO_BOOK: 'ready_to_book',
  ONGOING_CARE: 'ongoing_care',
  CONCERNS_TREATMENT: 'concerns_treatment',
};

export const isMatchFresh = (match) =>
  match?.id && moment().diff(moment(match?.createdAt), 'days') <= 30;

export const generateSafeUrl = (url) =>
  (url.substring(url.length - 1) === '/' ? url : `${url}/`);

const formatAnalyticsParam = (value) => value?.toString() || '';

export const isUsUser = (storage) => {
  if (!storage) {
    Logger.warning('isUsUser: storage is required');
    return false;
  }
  const locationStepData = storage.get(STEP_KEY.LOCATION);
  return locationStepData?.address?.country === COUNTRY.unitedStates;
};

// Used in analytic events under the "content" key
export const generateStepAnalytics = (stepPosition, storage, content) => {
  const funnelConfigId = formatAnalyticsParam(storage?.config?.id);
  const funnelConfigTestId = formatAnalyticsParam(storage?.config?.test);
  const funnelConfigTestVariant = formatAnalyticsParam(
    storage?.config?.variant,
  );
  const funnelConfigBranchName = formatAnalyticsParam(
    storage?.config?.branchName,
  );

  const unselectedControlConfigs = storage?.config?.unselectedControlConfigs;

  const locationStepData = storage.get(STEP_KEY.LOCATION);
  const {
    country,
    locality,
    administrative_area_level_1_short: region,
    postal_code: postalCode,
  } = locationStepData?.address || {};
  const userMarket = formatAnalyticsParam(locationStepData?.marketName);
  const customProperties = content?.response && { response: content.response };
  return {
    funnelConfigId,
    funnelConfigTestId,
    funnelConfigTestVariant,
    funnelConfigBranchName,
    userMarket,
    customProperties,
    ...country && {
      userSuppliedLocation: {
        country,
        city: locality,
        state: region,
        postal: postalCode,
      },
    },
    content: {
      ...content || {},
      'step-position': `${stepPosition}`,
      'funnel-config': funnelConfigId,
      ...unselectedControlConfigs && {
        'unselected-control-configs': unselectedControlConfigs,
      },
    },
  };
};
